
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9hAXc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $af004d2fae0e767c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $af004d2fae0e767c$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': 'Typ iets ...',
    'fabric.editor.editorAssistiveLabel': 'Hoofdveld content, begin met typen om tekst in te voeren.',
    'fabric.editor.headingLink.toolbarHelpTitle': 'Open helpdialoogvenster'
};

});


//# sourceMappingURL=nl.5eabbf2e.js.map
